import { render, staticRenderFns } from "./MinibusRequestManagement.vue?vue&type=template&id=891dbca2&"
import script from "./MinibusRequestManagement.vue?vue&type=script&lang=js&"
export * from "./MinibusRequestManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports